import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import { FileLikeObject } from 'ng2-file-upload';

import { Task } from 'src/app/model/sales/task.model';
import { LeadNote } from 'src/app//model/sales/lead-note.model';
import { Timeline } from 'src/app//model/sales/timeline.model';
import { Merchant } from 'src/app/model/sales/merchant.model';
import { Settings } from 'src/app/model/sales/settings.model';
import { UploadInfo } from 'src/app/model/sales/upload-info.model';
import { environment } from 'src/environments/environment';
import { Provisioning } from 'src/app/model/support/provisioning.model';

@Injectable({
  providedIn: 'root'
})
export class InstallationService {

  private path = environment.apiURL + 'install';

  constructor(private http: HttpClient) {
  }

  public list(partnerId: number): Observable<Array<Merchant>> {
    const params = new HttpParams().set('partnerId', partnerId);

    return this.http
               .get<Merchant[]>(this.path,
                                {params: params});
  }

  public cancel(merchantId: number,
                reason?: string): Observable<void> {
    let params = new HttpParams();

    if(reason){
      params = params.set('reason', reason);
    }

    return this.http
               .delete<void>(this.path + '/' + merchantId,
                            {params});
  }

  public addHandheld(merchantId: number,
                     provisioning: Provisioning): Observable<void> {
    return this.http
               .post<any>(this.path + '/' + merchantId + '/handheld',
                          provisioning);
  }

  public addStation(merchantId: number,
                    provisioning: Provisioning): Observable<void> {
    return this.http
               .post<any>(this.path +'/' + merchantId + '/station',
                          provisioning);
  }

  public setSettings(merchantId: number,
                     settings: Settings): Observable<Merchant> {

    return this.http
               .put<Merchant>(this.path +'/' + merchantId + '/settings',
                              settings);
  }

  public copySettings(merchantId: number,
                      masterId: number): Observable<Merchant> {
    const params = new HttpParams().set("masterId", masterId);

    return this.http
               .put<Merchant>(this.path +'/' + merchantId + '/copy',
                              null,
                              {params: params});
  }

  public timeline(merchantId: number): Observable<Array<Timeline>> {

    return this.http
               .get<Timeline[]>(this.path + '/' + merchantId + '/timeline');
  }

  public noteCreate(merchantId: number,
                    note: LeadNote): Observable<LeadNote> {

    const params = new HttpParams().set('title', note.title)
                                   .set('details', note.content);

    return this.http
               .put<LeadNote>(this.path + '/' + merchantId + '/note',
                              {},
                              {params: params});
  }

  public deleteNote(merchantId: number,
                attachmentId: number): Observable<Merchant> {
    return this.http
               .delete<Merchant>(this.path + '/' + merchantId + '/note/' + attachmentId);
  }

  public docs(token: string): Observable<UploadInfo> {
    const options = { headers: new HttpHeaders({'Authorization': token}) };

    return this.http
               .get<UploadInfo>(this.path + '/docs',
                                options);
  }

  public emailDocsUploadLink(merchantId: number,
                             to: string): Observable<any> {
    let params = new HttpParams().set("to", to);

    return this.http
               .put<any>(this.path + '/' + merchantId + '/link',
                         {},
                         {params: params});
  }

  public live(merchantId: number,
              date: Date,
              fees = true): Observable<Merchant> {
    const params = new HttpParams().set('date',
                                         date.toISOString())
                                  .set('monthlyFees',
                                        fees);

    return this.http
               .put<Merchant>(this.path + '/' + merchantId + '/live',
                              {},
                              {params: params});
  }

  public tasks(merchantId: number): Observable<Array<Task>> {
    return this.http
               .get<Array<Task>>(this.path + '/' + merchantId + '/task');
  }

  public task(merchantId: number,
              task: Task): Observable<void> {
    let params = new HttpParams();

    if (task.scheduled) {
      params = params.append('scheduled',
                             task.scheduled.toISOString());
    }

    if (task.completed) {
      params = params.append('completed',
                             task.completed.toISOString());
    }

    if (task.description) {
      params = params.append('description',
                             task.description);
    }

    return this.http
               .put<void>(this.path + '/' + merchantId  + '/task/' + task.taskId,
                          {},
                          {params: params});
  }

  public uploadByMerchant(merchantId: number,
                          task: Task,
                          upstream: any,
                          metaData: any): Observable<string> {

    let params = new HttpParams();

    params = params.append("taskId", task.taskId);
    params = params.append("stream", upstream);
    params = params.append("metaData", metaData);

    if (task.name) {
      params = params.append("name", task.name);
    }

    if (task.type) {
      params = params.append("type", task.type);
    }

    if (task.description) {
      params = params.append("description", task.description);
    }
    console.log('PARAMS', params);

    return this.http
               .post<string>(this.path + '/upload',
                             {},
                             {params: params});
  }

  public upload(merchantId: number,
                task: Task,
                file: any): Observable<Task> {

    const headers = new HttpHeaders();

    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    const formData = new FormData();

    formData.append('task',
                    new Blob([JSON.stringify(task)],
                    { type: 'application/json' }));
    formData.append('file',
                    file,
                    file.name);

    return this.http
               .post<Task>(this.path+ '/' + merchantId + '/upload',
                           formData,
                           {headers: headers});
  }

  public download(taskId: number, installationId: number): any {
    return this.http
               .get(this.path + '/' + installationId + '/task/' +taskId + '/attachment',
                    {responseType: 'arraybuffer'});
  }
}
